<template>
  <div>
    <span
      class="status-label"
      :style="{ backgroundColor: stateColor.backgroundColor, color: stateColor.fontColor }"
      >{{ stateText }}</span
    >
  </div>
</template>

<script>
export default {
  name: "StateChip",
  components: {},
  props: {
    stateText: String,
    stateColor: [String, Object],
  },
};
</script>

<style scoped>
.status-label {
  border-radius: 9999px;
  padding: 0.4em 0.8em;
  font-weight: 500;
  display: inline-block;
  font-size: 14px;
  white-space: nowrap;
}
</style>
